import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twisto/styles';

export const container = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  opacity: 0;
  transition: opacity 50ms ease-in-out;
`;

export const visible = css`
  opacity: 1;
`;

export const bubble = (theme: Theme) => css`
  position: absolute;
  top: -${theme.spacing[24]};
  left: 0;
  width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const arrow = (theme: Theme) => css`
  flex: 0 0 auto;
  transform: translateX(-50%);
  fill: ${theme.palette.accent.lowContrast};
`;

export const text = (theme: Theme) => css`
  display: flex;
  user-select: none;
  flex: 0 0 auto;
  transform: translateX(-50%);
  align-items: center;
  justify-content: center;
  min-width: ${theme.spacing[24]};
  background-color: ${theme.palette.accent.lowContrast};
  padding: 1px ${theme.spacing[4]};
  border-radius: ${theme.borderRadius.sm};
  color: ${theme.palette.accent.highContrast};
  font-size: ${theme.typography.app.bodyMobile.fontSize}px;
  line-height: ${theme.typography.app.bodyMobile.lineHeight}px;
  letter-spacing: ${theme.typography.app.bodyMobile.letterSpacing}px;
  white-space: nowrap;

  ${breakpoint.up('sm')} {
    padding-block: 0;
    font-size: ${theme.typography.app.body.fontSize}px;
    line-height: ${theme.typography.app.body.lineHeight}px;
    letter-spacing: ${theme.typography.app.body.letterSpacing}px;
  }
`;
